<template>
  <p v-if="isMoneyBackGuarantee">
    <strong>{{ refundableDays }} day money-back guarantee.</strong>
    {{ refundText }}
  </p>
  <p v-else-if="hasFreeIntervalPlan">
    <strong>{{ intervalText }}</strong>
    Simply redeem the product within 60 days.
  </p>
  <p v-else-if="isRedeemBy">
    <strong>Get lifetime access.</strong>
    Just download and save within 60 days{{ isFreebie ? '' : ' of purchase' }}.
  </p>
</template>

<script>
export default {
  props: {
    calloutType: {
      type: String,
      required: true,
    },
    refundableDays: {
      type: Number,
      required: true,
    },
    isFreebie: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isMoneyBackGuarantee() {
      return this.calloutType === 'money-back';
    },
    isRedeemBy() {
      return this.calloutType === 'redeem-by';
    },
    hasFreeIntervalPlan() {
      return this.calloutType && this.calloutType.includes('-free');
    },
    intervalText() {
      if (this.calloutType === 'annual-free') {
        return 'Get 1 year of access.';
      }

      if (this.calloutType === 'month-free') {
        return 'Get 1 month of access.';
      }

      return 'Get access now.';
    },
    refundText() {
      // 60 and 30 days are most commonly used, so keep using the word "month"
      // Add a fallback for less common intervals
      let timeText = this.refundableDays !== 1
        ? `${this.refundableDays} days`
        : `${this.refundableDays} day`;

      if (this.refundableDays === 60) {
        timeText = '2 months';
      } else if (this.refundableDays === 30) {
        timeText = '1 month';
      }

      return `Try it out for ${timeText} to make sure it's right for you!`;
    },
  },
};
</script>

<style scoped>
  p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }
</style>
